import { MotiView } from "moti";
import React from "react";

import { LoadingSpinnerIcon } from "../../icons_v2/general/icons/LoadingSpinnerIcon";
import { IconProps } from "../../primitive";

export const LoadingSpinner = (props: IconProps) => {
  return (
    <MotiView
      style={{
        width: 24,
        height: 24,
        justifyContent: "center",
        alignItems: "center",
        transformOrigin: "center",
      }}
      from={{
        transform: [{ rotate: "0deg" }],
      }}
      animate={{
        transform: [{ rotate: "360deg" }],
      }}
      transition={{
        rotate: {
          loop: true,
          repeatReverse: false,
          type: "timing",
          duration: 1000,
          delay: 0,
        },
      }}
    >
      <LoadingSpinnerIcon {...props} />
    </MotiView>
  );
};
